import { HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError } from "rxjs";
import { Router } from "@angular/router";
import { MensagemService } from "../mensagem.service";
import { DadosCalculadoraService } from "../dados-calculadora.service";

export function errorInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn) {

    // const dadosCalculadoraService = inject(DadosCalculadoraService);
    // dadosCalculadoraService.input = null;
    // dadosCalculadoraService.output = null;
    // dadosCalculadoraService.extra = null;
    // dadosCalculadoraService.xml = null;

    if (request.url.includes('ncm') || request.url.includes('nbs') || request.url.includes('xml')) {
        return next(request);
    }

    const router = inject(Router);
    const mensagemService = inject(MensagemService);
    return next(request).pipe(
        catchError((e) => {
            if (e.error == null) {
                mensagemService.mostrar('Erro', 'Erro', e?.message);
            }
            if (e) {
                switch (e.error.code) {
                    case 'AUTHENTICATION_EXCEPTION':
                    case 'BAD_CREDENTIALS_EXCEPTION':
                    case 'TOKEN_EXPIRED_EXCEPTION':
                    case 'SIGNATURE_VERIFICATION_EXCEPTION':
                    case 'JWT_DECODE_EXCEPTION':
                        //router.navigate(['/login']);
                        break;
                    default:
                        mensagemService.mostrar('Erro', e?.error?.title, e?.error?.detail);
                        break;
                }
            }
            throw e;
        })
    );
}